var Datepicker = function Datepicker() {
  return {
    width: {
      day: 32
    },
    height: {
      day: 20
    }
  };
};

export default Datepicker;